import { Box } from "@mui/material";
import { useEffect, useState } from "react";

export const AwaitingResponse = () => {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev === 3 ? 1 : prev + 1));
    }, 400); // Change speed as desired
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        m: 1,
        p: 2,
        borderRadius: "8px",
        borderBottomLeftRadius: 0,
        backgroundColor: "white",
        minWidth: "2em",
        display: "flex",
      }}
    >
      {Array.from({ length: dotCount }).map((_, index) => (
        <Box
          key={index}
          sx={{
            backgroundColor: "grey.400",
            height: "8px",
            width: "8px",
            borderRadius: "50%",
            mr: 0.25,
          }}
        ></Box>
      ))}
    </Box>
  );
};
